import React from "react"
import { toast } from "react-toastify"
import ToastError from "../icons/toast-error.svg?url"
import ToastSuccess from "../icons/toast-success.svg?url"

const ToastBody = props => {
    let img, title
    switch (props.type) {
        case "success":
            img = ToastSuccess
            title = "SUCCESS"
            break
        case "error":
            title = "FAILED"
            img = ToastError
            break
        default:
            return props.msg
    }

    return (
        <>
            <div className="mytoast-left">
                <img src={img} alt="" />
            </div>
            <div className="mytoast-right">
                <div className="mytoast-top">{title}</div>
                <div className="mytoast-bottom">{props.msg}</div>
            </div>
        </>
    )
}

const Toast = {
    success: (msg, options = {}) => toast.success(<ToastBody msg={msg} type="success" />, options),
    error: (msg, options = {}) => toast.error(<ToastBody msg={msg} type="error" />, options),
}

export default Toast
